<ng-container *ngIf="formRef?.control as formRefControl">
  <h1 class="formSection__header">{{ 'Common.DateAndTimeInfo' | translate }}</h1>
  <form [formGroup]="formRefControl" class="cmn-forms dateInfo">
    <div class="formGrid__esvr formGrid__esvr--3">
      <div class="formSection__input no-border-input">
        <h2 class="input__title">{{ 'Common.DispatchTime' | translate }}</h2>
        <div *ngIf="editing; else elseDispatchTime">
          <mat-form-field floatLabel="never">
            <input
              matInput
              formControlName="dispatchTime"
              [owlDateTime]="dispatchTimeOwlDateTime"
              [owlDateTimeTrigger]="dispatchTimeOwlDateTime"
              readonly
            />
            <mat-icon matPrefix>today</mat-icon>
            <owl-date-time #dispatchTimeOwlDateTime></owl-date-time>
          </mat-form-field>
        </div>
        <ng-template #elseDispatchTime>
          <p>{{ getFieldValue('dispatchTime') | commonDate: 'with24Time' }}</p>
        </ng-template>
      </div>
      <div class="formSection__input no-border-input">
        <h2 class="input__title">{{ 'Common.CompletedTime' | translate }}</h2>
        <div *ngIf="editing; else elseCompletedTime">
          <mat-form-field floatLabel="never">
            <input
              matInput
              formControlName="completedTime"
              [owlDateTime]="completedTimeOwlDateTime"
              [owlDateTimeTrigger]="completedTimeOwlDateTime"
              readonly
            />
            <mat-icon matPrefix>today</mat-icon>
            <owl-date-time #completedTimeOwlDateTime></owl-date-time>
          </mat-form-field>
        </div>
        <ng-template #elseCompletedTime>
          <p>{{ getFieldValue('completedTime') | commonDate: 'with24Time' }}</p>
        </ng-template>
      </div>
    </div>
  </form>
</ng-container>
